import { useRoles } from '../hooks/useRoles';

const RoleProtectedRoute = ({ 
  children, 
  requiredRole, 
  requiredRoles = [], 
  requiredPermission,
  fallback = null 
}) => {
  const { hasRole, hasAnyRole, can } = useRoles();

  // Verificar si el usuario tiene el rol requerido
  const hasRequiredRole = () => {
    if (requiredRole) {
      return hasRole(requiredRole);
    }
    if (requiredRoles.length > 0) {
      return hasAnyRole(requiredRoles);
    }
    if (requiredPermission) {
      return can(requiredPermission);
    }
    return true; // Si no se especifica ningún requisito, permitir acceso
  };

  // Si no tiene el rol requerido, mostrar fallback o nada
  if (!hasRequiredRole()) {
    return fallback || null;
  }

  return children;
};

export default RoleProtectedRoute; 